<template>
  <div
    v-if="!img"
    :style="`width: ${size}px; height: ${size}px`"
    :class="`tw-text-[#ffffff] tw-text-[10px] text-alt tw-items-center tw-rounded-[50%] tw-flex tw-justify-center`"
  >
    {{ getAltName(altName) }}
  </div>
  <img
    v-if="img"
    :src="img"
    class="tw-rounded-[50%]"
    :style="`width: ${size}px; height: ${size}px`"
  />
</template>

<script setup lang="ts">
import { getAltName, getDefaultBackgroundColor } from "@/utils/utilities";
import { computed } from "vue";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  img: {
    type: String,
    required: false,
    default: "",
  },
  altName: {
    type: String,
    required: true,
    default: "avatar",
  },
  size: {
    type: Number,
    required: false,
    default: 30,
  },
});

const color = computed(() => {
  return getDefaultBackgroundColor(props.altName)
    ? `${getDefaultBackgroundColor(props.altName)}`
    : "#E4F1FF";
});
</script>

<style scoped lang="scss">
.text-alt {
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: 0.5px;
  background-color: v-bind(color);
}
</style>
